import { render, staticRenderFns } from "./NeedApp.vue?vue&type=template&id=1c36fdae&"
import script from "./NeedApp.vue?vue&type=script&lang=js&"
export * from "./NeedApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedApp.vue"
export default component.exports